module.exports = __webpack_public_path__ + "static/media/crew-symbol.8bb7039e.svg";